'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Description = exports.Title = exports.Definition = exports.Definitions = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  color: ', ';\n  margin: 0;\n  padding: 0;\n  text-decoration: none;\n  font-size: 14px;\n'], ['\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  color: ', ';\n  margin: 0;\n  padding: 0;\n  text-decoration: none;\n  font-size: 14px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  padding: 2px 0;\n  margin-bottom: ', 'px;\n'], ['\n  display: flex;\n  padding: 2px 0;\n  margin-bottom: ', 'px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  position: relative;\n  flex: 1;\n  font-family: ', ';\n  color: ', ';\n  margin: 0;\n  clear: left;\n'], ['\n  position: relative;\n  flex: 1;\n  font-family: ', ';\n  color: ', ';\n  margin: 0;\n  clear: left;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  position: relative;\n  flex: 1;\n  color: ', ';\n  margin: 0;\n  text-align: right;\n'], ['\n  position: relative;\n  flex: 1;\n  color: ', ';\n  margin: 0;\n  text-align: right;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Definitions = exports.Definitions = _styledComponents2.default.dl(_templateObject, function (props) {
  return props.theme.color.base1;
});

Definitions.displayName = 'Definitions';
var Definition = exports.Definition = _styledComponents2.default.div(_templateObject2, function (props) {
  return props.rowspacing;
});

Definition.displayName = 'Definition';
var Title = exports.Title = _styledComponents2.default.dt(_templateObject3, function (props) {
  return props.theme.font.bold;
}, function (props) {
  return props.theme.color.base1;
});

Title.displayName = 'Title';
var Description = exports.Description = _styledComponents2.default.dd(_templateObject4, function (props) {
  return props.theme.color.base2;
});
Description.displayName = 'Description';


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-definition/styles.js
// module id = 2902
// module chunks = 4